angular.module("LeasePilot").controller("SecurityController", [
  "$scope",
  "railsResourceFactory",
  "railsSerializer",
  "$mdToast",
  function($scope, railsResourceFactory, railsSerializer, $mdToast) {
    var SecurityService = railsResourceFactory({
      url: '/api/company/ip_filters',
      name: 'security',
      serializer: railsSerializer(function() {
        this.serializeWith(function(data) {
          return { ip_filter: data.ipFilter };
        });
      })
    });

    $scope.loading = false;
    $scope.security = {
      ipRangesText: "",
      currentIp: null,
      originalIpFilter: ""
    };

    // Sanitize plain-text textarea: strip tags, Angular expressions, javascript: URIs
    $scope.sanitize = function(value) {
      if (value === null || value === undefined) return '';
      var str = String(value);
      // Remove any HTML tags
      str = str.replace(/<[^>]*>/g, '');
      // Remove Angular-style interpolation expressions
      str = str.replace(/\{\{[\s\S]*?\}\}/g, '');
      // Neutralize javascript: URIs if any text tries to include them
      str = str.replace(/javascript:/gi, '');
      return str.trim();
    };

    function showToast(message, type = "error") {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(message)
          .position("top right")
          .hideDelay(3000)
          .theme("error-toast")
      );
    }

    function handleError(error) {
      console.error("API Error:", error);
      if (error.status === 401) {
        showToast("Failed to save security settings");
        return;
      }
      if (error.data && error.data.error) {
        const message = Array.isArray(error.data.error)
          ? error.data.error[0]
          : error.data.error;
        showToast(message);
      } else {
        showToast("An unexpected error occurred");
      }
    }

    function validateIp(ip) {
      // IPv4 validation
      const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
      if (ipv4Regex.test(ip)) {
        const parts = ip.split(".");
        return parts.every(part => {
          const num = parseInt(part, 10);
          return num >= 0 && num <= 255;
        });
      }

      // IPv6 validation
      const ipv6Regex = /^(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}$|^::(?:[A-F0-9]{1,4}:){0,6}[A-F0-9]{1,4}$|^[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,5}[A-F0-9]{1,4}$|^[A-F0-9]{1,4}:[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,4}[A-F0-9]{1,4}$|^(?:[A-F0-9]{1,4}:){0,2}[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,3}[A-F0-9]{1,4}$|^(?:[A-F0-9]{1,4}:){0,3}[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,2}[A-F0-9]{1,4}$|^(?:[A-F0-9]{1,4}:){0,4}[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:)?[A-F0-9]{1,4}$|^(?:[A-F0-9]{1,4}:){0,5}[A-F0-9]{1,4}::[A-F0-9]{1,4}$|^(?:[A-F0-9]{1,4}:){0,6}[A-F0-9]{1,4}::$|^::$|^(?:[A-F0-9]{1,4}:){1,7}:|^:(?::[A-F0-9]{1,4}){1,7}$|^::(?:[A-F0-9]{1,4}:){0,5}(?:\d{1,3}\.){3}\d{1,3}$|^[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,5}(?:\d{1,3}\.){3}\d{1,3}$|^[A-F0-9]{1,4}:[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,4}(?:\d{1,3}\.){3}\d{1,3}$|^(?:[A-F0-9]{1,4}:){0,2}[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,3}(?:\d{1,3}\.){3}\d{1,3}$|^(?:[A-F0-9]{1,4}:){0,3}[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:){0,2}(?:\d{1,3}\.){3}\d{1,3}$|^(?:[A-F0-9]{1,4}:){0,4}[A-F0-9]{1,4}::(?:[A-F0-9]{1,4}:)?(?:\d{1,3}\.){3}\d{1,3}$|^(?:[A-F0-9]{1,4}:){0,5}[A-F0-9]{1,4}::(?:\d{1,3}\.){3}\d{1,3}$/i;
      
      if (ipv6Regex.test(ip)) {
        // Additional validation for IPv4-mapped IPv6 addresses
        if (ip.includes('.')) {
          const ipv4Part = ip.split(':').pop();
          const ipv4Parts = ipv4Part.split('.');
          return ipv4Parts.every(part => {
            const num = parseInt(part, 10);
            return num >= 0 && num <= 255;
          });
        }
        return true;
      }

      return false;
    }

    function validateCidr(cidr) {
      const parts = cidr.split("/");
      if (parts.length !== 2) return false;

      const ip = parts[0];
      const prefix = parseInt(parts[1], 10);

      return validateIp(ip) && prefix >= 0 && prefix <= 32;
    }

    function validateIpRange(range) {
      const parts = range.split("-").map(p => p.trim());
      if (parts.length !== 2) return false;

      return validateIp(parts[0]) && validateIp(parts[1]);
    }

    function validateIpEntry(entry) {
      entry = entry.trim();
      if (!entry) return true; // Allow empty lines

      if (entry.includes("/")) {
        return validateCidr(entry);
      } else if (entry.includes("-")) {
        return validateIpRange(entry);
      } else {
        return validateIp(entry);
      }
    }

    $scope.loadIpFilters = function() {
      $scope.loading = true;

      SecurityService.get()
        .then(function(response) {
          $scope.security.currentIp = response.currentIp;
          // Store original IP filter for tracking
          $scope.security.originalIpFilter = response.ipFilter || "";
          // Convert pipe-separated string to newline-separated text
          $scope.security.ipRangesText = $scope.sanitize(
            response.ipFilter ? response.ipFilter.split("|").join("\n") : ""
          );
          $scope.loading = false;
        })
        .catch(function(error) {
          handleError(error);
          $scope.loading = false;
        });
    };

    $scope.updateIpRanges = function() {
      // Sanitize raw textarea input
      $scope.security.ipRangesText = $scope.sanitize($scope.security.ipRangesText);
      // Split by newlines and filter out empty lines
      const ranges = $scope.security.ipRangesText
        .split("\n")
        .map(line => line.trim())
        .filter(line => line.length > 0);

      // Validate each line
      const invalidRanges = ranges.filter(range => !validateIpEntry(range));
      if (invalidRanges.length > 0) {
        showToast(`Invalid IP format: ${invalidRanges[0]}`);
        return;
      }

      // Convert newlines to pipes for storage
      const ipFilterString = ranges.join("|");

      new SecurityService({ ipFilter: ipFilterString })
        .update()
        .then(function(response) {
          window.track.event(new IPRestrictionsChangedEvent({
            before: $scope.security.originalIpFilter,
            after: ipFilterString
          }));
          window.location.reload();
        })
        .catch(handleError);
    };

    // Initialize
    $scope.loadIpFilters();
  }
]);
